import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { Loader, Dimmer } from "semantic-ui-react";
import {
  saveNewCustomerData,
  saveEditedCustomerData,
  setIsLoadingOnCustomerProfile,
  updateBookingOnlyCustomerProfileData,
  updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile,
} from "../../../actions/customerProfile";
import { updateGlobalErrorMessage } from "../../../actions/globalError";
import objectAssign from "object-assign";
import { forceValidation } from "../../shared/validMeReact";
import { saveCustomerDataHandler } from "../../shared/saveCustomerDataHandler";
import { updateCurrentMenu } from "../../../actions/menu";
import { menuNamesEnum } from "../../../state/initialState";
import { updateAppointmentStepData } from "../../../actions/appointmentStep";

@connect(mapStateToProps)
export default class BottomPanelCustomerProfile extends Component {
  constructor(props) {
    super(props);
  }

  saveClickHandler = () => {
    let {
      customerProfileData,
      advancedAppointmentStepData,
      apiCustomerProfileData,
      appointmentStepData,
    } = this.props;

    let cb = () => {
      this.props.dispatch(updateGlobalErrorMessage(""));

      const newAppointmentStepData = objectAssign({}, appointmentStepData, {
        selectedCustomer: customerProfileData,
        address: customerProfileData.address,
      });
      this.props.dispatch(updateAppointmentStepData(newAppointmentStepData));

      const bookingCustomerProfile = {};

      bookingCustomerProfile.email = customerProfileData.email || "";
      bookingCustomerProfile.phoneNumber =
        customerProfileData.phoneNumber || "";
      bookingCustomerProfile.firstName = customerProfileData.firstName || "";
      bookingCustomerProfile.lastName = customerProfileData.lastName || "";
      bookingCustomerProfile.address = customerProfileData.address || {};

      // Always override the booking details
      this.props.dispatch(
        updateBookingOnlyCustomerProfileData(bookingCustomerProfile)
      );

      sessionStorage.setItem(
        "BOOKING_APPOINTMENT_SNAPSHOT",
        JSON.stringify({
          appointmentStepData: newAppointmentStepData,
          advancedAppointmentStepData,
        })
      );

      setTimeout(() => {
        this.props.dispatch(
          updateCurrentMenu(menuNamesEnum.FIRST_STEP_APPOINTMENT)
        );
      }, 0); // this is required because the cb is not called after the customer has been updated in the app state, but rather, before that, so we wait until the next JS app cycle
    };

    saveCustomerDataHandler(
      customerProfileData,
      apiCustomerProfileData,
      this.props.dispatch,
      cb
    );
  };

  render() {
    let { deleted } = this.props.customerProfileData;
    let saveClasses = "ui right floated button btn-default save-customer";

    if (deleted) {
      saveClasses += " disabled";
    }
    return (
      <div className="ui clearing aligned booking_footer">
        <br />
        <div className="action_buttons">
          <div
            deleted={deleted}
            onClick={this.saveClickHandler}
            data-group="customerProfileNames&customerProfile&customerProfileContacts"
            className={saveClasses}
          >
            {window.APP.LANGUAGE.Pages.CustomerProfile.SaveButtonText}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    bookingOnlyCustomerProfileData:
      state.customerProfileReducer.bookingOnlyCustomerProfileData,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    apiCustomerProfileData: state.customerProfileReducer.apiCustomerProfileData,
    loadingCustomerProfile: state.customerProfileReducer.loadingCustomerProfile,
  };
}
